import { useEffect, useState } from "react";
import {
    DataTexture,
    EquirectangularReflectionMapping,
    LinearFilter,
    LinearMipMapLinearFilter,
    sRGBEncoding,
} from "three";
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader";

const HDRI = `${process.env.PUBLIC_URL}/assets/hdr/royal_esplanade_1k.hdr`;
const hdrTexture: { env: DataTexture | null; isLoading: boolean } = { env: null, isLoading: false };
const loader = new RGBELoader();

export const useHDR = () => {
    const [hdrTextureState, setHdrTexture] = useState<DataTexture | null>(hdrTexture.env);
    const [isLoading, setIsLoading] = useState<boolean>(hdrTexture.isLoading);

    useEffect(() => {
        if (!hdrTexture.env && !hdrTexture.isLoading) {
            setIsLoading(true);
            hdrTexture.isLoading = true;
            loader.load(
                HDRI,
                (texture) => {
                    texture.mapping = EquirectangularReflectionMapping;
                    texture.magFilter = LinearFilter;
                    texture.minFilter = LinearMipMapLinearFilter;
                    texture.encoding = sRGBEncoding;
                    hdrTexture.env = texture;
                    hdrTexture.isLoading = false;
                    setIsLoading(false);
                    setHdrTexture(texture);
                },
                undefined,
                (err) => {
                    console.log(err.type);
                    hdrTexture.isLoading = false;
                    setIsLoading(false);
                }
            );
        }
    }, []);

    return {
        hdrTexture: hdrTextureState,
        isLoading,
    };
};
